import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown } from 'primereact/dropdown';
import { useSelector, useDispatch } from 'react-redux';

import { setSelectedMaterial } from '../actions';
import { updateMaterial, refreshReferential } from '../../app/updateApp';
import { faTruckPlow } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DropDownMaterial = props => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const materialState = useSelector(state => state.materials);

    return <div className="userSelection material">
        <div style={{ display: 'flex', margin: '0 0px', alignItems: 'center', flexDirection: 'row' }}>
            <FontAwesomeIcon style={{ color: '#fbc601', fontSize: '42px', marginRight: '14px' }} icon={faTruckPlow} />
            <Dropdown
                autoFocus
                className="p-shadow-2 materiel"
                emptyMessage={t('app:no_result_found')}
                value={materialState.selectedMaterial}
                options={props.materials?.map(mat => { return {
                    value: mat.id,
                    label: `${mat.type} > ${mat.designation} (${mat.numero})`,
                    code: ''+mat.numero
                };})}
                filterBy="code,label"
                onChange={(e) => { dispatch(setSelectedMaterial(e.target.value)); refreshReferential().then(() => updateMaterial(e.target.value)); }}
                filter
                placeholder={t('app:no_selected_material')}
            />
        </div>
    </div>;
};

export default DropDownMaterial;

